let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bPhKw")).then(() => parcelRequire('iofEW'));